import React, { useContext, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { LoginContext } from "../context/LoginContext"
import { ToastContainer, toast } from 'react-toastify';
import ReCAPTCHA from "react-google-recaptcha"
import axios from 'axios';
import { apiEndPoint } from '../../environment';

export default function Login() {
    const { loginUser, error, loadingLogin } = useContext(LoginContext)
    const captchaRef = useRef(null)

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = captchaRef.current.getValue();
        captchaRef.current.reset();

        let data = JSON.stringify({
            "token": token
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${apiEndPoint}user`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios.request(config)
            .then((response) => {
                if (response.data == 'Human') {
                    loginUser(email, password)
                } else {
                    console.log("Robat Login");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    return (
        <>

            <div className="container">
                <div className="row flex-center text-center min-vh-100 py-6" style={{ paddingTop: '0 !important' }}>
                    <div className="col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4">
                        <a className="d-flex flex-center mb-4" href="https://webnoti.netlify.app">
                            <svg version={1.0} xmlns="http://www.w3.org/2000/svg" width="200px" viewBox="0 0 1480.000000 303.000000" preserveAspectRatio="xMidYMid meet">
                                <g transform="translate(0.000000,303.000000) scale(0.100000,-0.100000)" fill="#484848" stroke="none">
                                    <path fill="#4a90e2" d="M1153 2955 c-202 -38 -401 -123 -553 -235 -151 -111 -294 -278 -383 -447 -43 -81 -102 -258 -122 -363 -50 -260 -5 -571 116 -812 84 -167 246 -358 394 -463 l64 -46 -92 -142 c-51 -78 -125 -192 -165 -253 -40 -61 -72 -113 -72 -116 0 -6 47 6 450 113 124 32 279 73 345 90 630 165 742 201 876 280 316 185 542 497 621 856 30 138 30 387 0 523 -112 510 -494 893 -1002 1005 -103 23 -381 29 -477 10z m267 -540 c39 -20 50 -43 50 -109 l0 -55 43 -12 c61 -16 152 -74 191 -122 69 -86 84 -136 96 -327 12 -190 42 -303 107 -401 19 -29 24 -47 21 -85 l-3 -49 -552 -3 -553 -2 0 59 c0 37 5 63 14 70 23 20 75 144 91 221 9 41 20 134 24 206 10 152 30 224 80 291 44 58 129 119 191 137 l45 13 5 54 c10 105 73 154 150 114z m90 -1280 c0 -130 -168 -193 -244 -92 -25 34 -42 90 -31 107 4 6 60 10 141 10 l134 0 0 -25z" />
                                    <path d="M6404 2676 c-11 -28 3 -1340 14 -1389 68 -286 288 -506 560 -559 85 -16 246 -14 323 5 357 88 583 430 539 815 -11 100 -17 123 -54 211 -91 214 -281 377 -493 425 -142 32 -304 16 -414 -40 -27 -13 -51 -24 -54 -24 -3 0 -5 128 -5 285 l0 285 -205 0 c-165 0 -207 -3 -211 -14z m819 -912 c68 -23 138 -91 173 -166 24 -53 28 -76 28 -144 0 -72 -4 -90 -33 -148 -20 -41 -47 -78 -74 -99 -73 -60 -104 -71 -192 -71 -58 0 -90 5 -115 18 -100 52 -159 131 -180 242 -37 187 113 384 291 384 30 0 76 -7 102 -16z" />
                                    <path d="M12307 2684 c-4 -4 -7 -443 -7 -976 l0 -968 210 0 209 0 3 439 3 439 30 44 c56 80 175 119 258 85 49 -21 98 -67 118 -112 17 -37 19 -74 19 -467 l0 -428 210 0 210 0 0 443 c0 411 -1 450 -20 522 -29 112 -79 196 -174 290 -128 127 -256 179 -436 179 -98 0 -124 -5 -202 -39 -17 -7 -18 12 -20 271 l-3 279 -201 3 c-110 1 -203 -1 -207 -4z" />
                                    <path d="M5554 2181 c-349 -86 -572 -423 -533 -807 36 -357 291 -616 641 -654 181 -20 341 22 492 127 62 44 186 171 186 193 0 3 -69 74 -154 159 l-154 154 -25 -49 c-30 -58 -86 -115 -142 -142 -43 -21 -125 -37 -125 -25 0 5 133 168 296 363 163 195 298 360 301 367 11 26 -115 159 -207 218 -130 83 -241 115 -400 114 -64 0 -133 -7 -176 -18z m184 -433 c-66 -94 -281 -373 -289 -376 -16 -6 -10 151 7 204 43 126 138 201 262 203 l43 1 -23 -32z" />
                                    <path d="M8530 2179 c-83 -22 -177 -70 -258 -131 l-53 -39 -19 23 c-11 13 -36 44 -57 70 l-38 47 -72 1 -73 0 0 -960 0 -960 210 0 210 0 0 284 0 285 63 -29 c133 -60 246 -73 389 -46 194 38 351 141 452 299 83 130 118 257 118 437 0 172 -30 282 -110 410 -160 254 -480 384 -762 309z m263 -415 c67 -23 129 -82 162 -156 36 -78 41 -192 12 -275 -23 -66 -86 -137 -151 -170 -71 -36 -189 -39 -258 -5 -56 28 -123 98 -149 157 -75 169 7 391 167 449 53 20 160 20 217 0z" />
                                    <path d="M3140 1664 c0 -541 1 -555 67 -673 108 -194 340 -307 559 -271 81 12 184 53 230 89 l26 21 29 -21 c103 -73 257 -109 391 -90 211 31 374 169 449 381 23 64 23 69 24 555 l0 490 -207 3 -207 2 -3 -467 c-3 -450 -4 -469 -23 -495 -66 -90 -205 -66 -235 41 -6 21 -10 218 -10 479 l0 442 -205 0 -205 0 0 -450 c0 -485 -1 -490 -53 -538 -59 -55 -164 -32 -198 42 -17 38 -19 75 -19 494 l0 452 -205 0 -205 0 0 -486z" />
                                    <path d="M9502 1698 c4 -433 5 -456 26 -526 82 -269 279 -430 559 -457 122 -12 279 36 393 120 26 19 50 35 53 35 3 0 26 -29 52 -65 l46 -65 70 0 69 0 0 705 0 705 -204 0 -205 0 -3 -417 c-3 -461 -2 -451 -69 -528 -84 -95 -219 -100 -305 -10 -27 28 -45 58 -52 88 -8 31 -12 179 -12 456 l0 411 -211 0 -210 0 3 -452z" />
                                    <path d="M11260 2136 c-177 -50 -307 -193 -340 -375 -14 -77 -5 -155 26 -240 46 -122 136 -214 265 -268 63 -27 69 -27 312 -31 214 -3 249 -6 254 -19 4 -10 -3 -23 -16 -35 -22 -17 -50 -18 -437 -18 l-414 0 0 -205 0 -206 468 3 467 3 70 30 c94 40 189 133 236 230 33 68 34 73 34 195 l0 125 -40 74 c-68 125 -182 206 -326 230 -36 6 -155 11 -265 11 -142 0 -203 3 -212 12 -16 16 -15 53 1 67 10 7 132 12 388 13 l374 3 3 208 2 207 -402 -1 c-292 -1 -415 -4 -448 -13z" />
                                    <path d="M13740 1445 l0 -705 210 0 210 0 0 415 c0 453 -1 444 59 508 53 58 69 62 291 67 l205 5 3 208 2 209 -232 -4 c-224 -3 -236 -5 -311 -31 -43 -15 -103 -43 -134 -63 -30 -19 -59 -34 -63 -32 -5 2 -29 31 -54 66 l-46 62 -70 0 -70 0 0 -705z" />
                                </g>
                            </svg>
                        </a>
                        <div className="card">
                            <div className="card-body p-5">
                                <div className="row text-left justify-content-between">
                                    <div className="col-auto">
                                        <h5> Sign in</h5>
                                    </div>
                                    <div className="col-auto">
                                        <p className="fs--1 text-600">or <Link to="/auth/register">Create an account</Link></p>
                                    </div>
                                </div>
                                <div className='text-danger h6'>{error}</div>
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <input type="email" className="text-field form-control" onChange={(event) => setEmail(event.target.value)} name="email" placeholder="Your Email address" required="required" />
                                        <input type="hidden" name="time_zone" />
                                    </div>
                                    <div className="form-group">
                                        <input type="password" className="text-field form-control" onChange={(event) => setPassword(event.target.value)} name="password" placeholder="Password" required="required" />
                                    </div>

                                    <div className="w-100 my-3 justify-content-between text-right">
                                        <div className="col-auto"><Link className="fs--1" to="/auth/forgot-password">Forgot Password?</Link></div>
                                    </div>

                                    <ReCAPTCHA className='ml-4' sitekey={process.env.REACT_APP_SITE_KEY} ref={captchaRef} />

                                    <div className="form-group">
                                        <button id="btn-submit" type="submit" className="btn btn-primary btn-block mt-3" data-placeholder="Signing in ..."> {loadingLogin ?
                                            <div className="spinner-border spinner-border-sm" role="status">
                                            </div> : ""} Sign In</button>
                                        <p className="fs--1 text-600 mt-2">I have read and agree to Webpushr's <a href="https://www.webpushr.com/privacy-policy">Data &amp; Privacy Policy</a> &amp; <a href="https://www.webpushr.com/terms-of-use">Terms of Use</a>.</p></div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
        </>
    )
}
